<template>
    <div class="option-general-wrapper">

        <div class="form-group row mt-0 mb-3 p-0">
            <label class="col-md-1 col-form-label text-right">Name</label>
            <div class="col-md-11">
                <edit-in-place type="short-text"
                               :property-value="valueName"
                               :is-master="versionSelected == 0"
                               :read-only="versionSelected != 0">
                        <api-handler
                            :option-id="optionData.id"
                            :version-id="versionSelected"
                            property-name="name"
                            @in-progress="$emit('lock-form-toggle', true)" @success="$emit('lock-form-toggle', false)" @error="$emit('lock-form-toggle', false)">
                        </api-handler>
                </edit-in-place>
            </div>
        </div>

        <div class="form-group row mt-0 mb-3 p-0">
            <label class="col-md-1 col-form-label text-right">Display Name</label>
            <div class="col-md-11">
                <edit-in-place type="short-text"
                               :property-value="displayName"
                               :is-master="versionSelected == 0"
                               :master-value="masterDisplayName">
                        <api-handler
                            :option-id="optionData.id"
                            :version-id="versionSelected"
                            property-name="display_name"
                            @in-progress="$emit('lock-form-toggle', true)" @success="$emit('lock-form-toggle', false)" @error="$emit('lock-form-toggle', false)">
                        </api-handler>
                </edit-in-place>
            </div>
        </div>

        <div class="form-group row mt-0 mb-3 p-0">
            <label for="type" class="col-md-1 col-form-label text-right">Type</label>
            <div class="col-md-11">
                <edit-in-place type="single-select"
                                :property-value="type"
                                :is-master="versionSelected == 0"
                                :master-value="masterType"
                                :null-select="false"
                                :options="[
                                    {value:'S', label:'Dropdown', },
                                    {value: 'RB', label:'Radio Buttons'},
                                    {value: 'RT', label: 'Rectangles'},
                                    {value: 'CS', label: 'Swatch'}
                                    ]">
                        <api-handler
                            :option-id="optionData.id"
                            :version-id="versionSelected"
                            property-name="type"
                            @in-progress="$emit('lock-form-toggle', true)" @success="$emit('lock-form-toggle', false)" @error="$emit('lock-form-toggle', false)">
                       </api-handler>
                </edit-in-place>
            </div>
        </div>

        <div class="load-indicator" v-show="showLoading">
            <span class="fa fa-cog fa-spin fa-1x"></span>
        </div>
    </div>
</template>

<script>
import EditInPlace from '../edit-in-place/edit-in-place.vue';
import OptionsGeneralApiHandler from '../edit-in-place/api-handlers/options-general.vue';

var base_url = window.location.protocol + "//" + window.location.host

export default {
    name: "general",
    components: {
        'edit-in-place': EditInPlace,
        'api-handler': OptionsGeneralApiHandler,
    },
    props: {
        versionSelected: String,
        optionData: Object,
        showLoading: {
            type: Boolean,
            defailt: false,
        }
    },
    data() {
        return {
            masterType: '',
            type: '',
            valueName: '',
            masterDisplayName: '',
            displayName: '',
            isUpdating: false,
            ignoreLastUpdate: false,
        }
    },
    watch: {
        optionData(newValue) {
            this.valueName = this.optionData.name;
            this.masterDisplayName = this.optionData.masterDisplayName,
            this.displayName = this.optionData.displayName;
            this.type = this.optionData.type;
            this.masterType = this.optionData.masterType;
            this.ignoreLastUpdate = true;
        }
    },
    methods: {}
};

</script>

<style>
</style>

